<section class="Service-section relative">
  <div class="icon-text header">
    <div><i class="material-icons">directions_run</i></div>
    <h1>Services</h1>
  </div>
  <mat-icon
    class="!h-36 !w-36 absolute text-[9.25rem] leading-none opacity-25 left-1/4 top-1/4 text-center self-center"
    >directions_run</mat-icon
  >
  <div class="service_content">
    @if (isLoading$ | async) {
      <div class="loading-indicator">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else {
      <div>
        <div class="service_count">
          <div class="number">{{ (totalOpenServices$ | async).length }}</div>
          <div class="description">
            <div class="service_status upper">Active</div>
            <div class="service_label">
              {{ totalOpenServices$ | async | pluralize: 'Service' }}
            </div>
          </div>
        </div>
        <div class="service_icon">
          <div class="total-locations">
            Spanning {{ totalLocations$ | async }}
            {{ totalLocations$ | async | pluralize: 'location' }}
          </div>
        </div>
      </div>
    }
  </div>
  <div class="widget_cta">
    <a routerLink="/services" [queryParams]="{ groupBy: 'Location' }"
      >View Services</a
    >
  </div>
  <a
    routerLink="/services"
    [queryParams]="{ groupBy: 'Location' }"
    tabindex="-1"
    class="dashboard-link desktop"
  >
    <div class="cta-link">desktop</div>
  </a>
</section>
